import React, { memo, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { cartConstants } from 'services/redux/cart/constants'
import HelperString from 'utils/helper-string'
import _ from 'lodash'
import FetchTimeslotCapacity from 'utils/fetch/FetchTimeslotCapacity'
import { removeCartTimeslots } from 'services/redux/cart/actions'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import Timeslot from 'components/molecules/Timeslot'
import TextDivider from 'components/atoms/TextDivider'
import ThemedBlock from 'components/atoms/ThemedBlock'
import Button from 'theme/Button'
import ExtendingFooter from 'scenes/home/book/_components/ExtendingFooter'
import { TESTID } from '_shared/config/testID'
import HelperTestID from 'utils/HelperTestID'
import i18n from 'utils/i18n'

const BookingFooter = ({ submitLabel = null, onPressSubmit, showSubmitButton = true, showBookings = true, disabled = false, loading = false, onHeight } ) => {
	
	const [ popupExtended, setPopupExtended ] = useState( false );
	
	const dispatch = useDispatch()
	
	const _cartTimeslots = useSelector( state => {
		return state.cart[cartConstants.TIMESLOTS];
	} );
	
	useEffect( () => {
		if( _.size( _cartTimeslots ) === 0 ) {
			setPopupExtended( false )
		}
	}, [ _cartTimeslots ] );
	
	const footerItems = useMemo( () => {
		if( !popupExtended ) {
			return null
		}
		
		const dayItems= {}
		_.forEach( _cartTimeslots, ( booking ) => {
			if ( _.get( dayItems, booking.booking_date, null ) === null ) {
				dayItems[ booking.booking_date ] = [];
			}
			
			const withActions = {
				cancelAction: ( booking, callback ) => {
					const key = FetchTimeslotCapacity.keyByBooking( booking );
					
					setTimeout( () => {
						dispatch( removeCartTimeslots( key ) );
						
						if( _.isFunction( callback ) ) {
							callback();
						}
					},  500 );
				}
			};
			
			dayItems[ booking.booking_date ].push(
				<Timeslot item={ booking } withActions={ withActions } />
			);
		})
		
		const result = []
		_.forEach( dayItems, ( dayItem, booking_date) => {
			result.push(
				<TextDivider key={ booking_date }  text={ booking_date } />
			);
			
			result.push(
				<ThemedBlock shadow>
					{ dayItem }
				</ThemedBlock>
			)
		});
		return result
	}, [ _cartTimeslots, popupExtended ] );
	
	const lastFooterItem = useMemo( () => {
		if( _.size( _cartTimeslots ) === 0 ) {
			return null;
		}
		
		// Get the last item
		const lastBooking = _cartTimeslots[ _.last( Object.keys( _cartTimeslots ) ) ]
		const lastBookingKey = FetchTimeslotCapacity.keyByBooking( lastBooking );
		
		return (
			<Timeslot
				testID={ TESTID.HOME.BOOK.BOOKING_FOOTER.EXTENDING_FOOTER_TIMESLOT }
				key={ HelperString.hash('footer-single', lastBookingKey ) }
				item={ lastBooking  }
				withFavourites={ false }
				animationOnMount={ false }
			/>
		);
	}, [ _cartTimeslots ] );
	
	useEffect( () => {
		if ( _.size( _cartTimeslots ) === 0 ) {
			onHeight( 0 );
		}
	}, [ _cartTimeslots ] );
	
	// Nothing? Just return null
	if ( _.size( _cartTimeslots ) === 0 ) {
		return null;
	}
	
	return (
		<ExtendingFooter
			testID={ popupExtended ? TESTID.HOME.BOOK.BOOKING_FOOTER.EXTENDING_FOOTER_EXTENDED : TESTID.HOME.BOOK.BOOKING_FOOTER.EXTENDING_FOOTER_COLLAPSED }
			onHeight={ onHeight }
			extended={ popupExtended }
			onPressExtend={ setPopupExtended }
			button={(
				<Button
					testID={ HelperTestID.generate( TESTID.HOME.BOOK.BOOKING_FOOTER.EXTENDING_FOOTER_COLLAPSED, [ TESTID.HOME.BOOK.BOOKING_FOOTER.SUFFIX_EXTENDING_FOOTER_SUBMIT_BUTTON ])}
					key={ HelperString.hash('booking-footer-submit-button') }
					isLoading={ loading }
					isLoadingText={ i18n.t('basic.loading' ) }
					disabled={ disabled }
					onPress={ onPressSubmit }>
					
					{ submitLabel }
				</Button>
			)}
			buttonVisible={ showSubmitButton }
			contentVisible={ showBookings }
			content={ lastFooterItem }
			contentIcon={ IconSystemConstants.CALENDAR }
			contentIconCount={ _.size( _cartTimeslots ) }
			contentExtended={ footerItems }
		/>
	)
}

export default memo( BookingFooter );
